/* Public Okendo product-review aggregate. No credentials, tracking or new widget. */
(() => {
  const key = '__ocCollectionReviewAggregate';
  if (!window[key]) {
    window[key] = fetch('https://api.okendo.io/v1/stores/3566d594-f495-4bf6-a37e-21d5a1bf8805/review_aggregate', {
      credentials: 'omit', signal: AbortSignal.timeout(5000)
    }).then(response => {
      if (!response.ok) throw new Error('Review totals unavailable');
      return response.json();
    }).then(({reviewAggregate: r}) => {
      const count = r?.reviewCount;
      const sum = r?.reviewRatingValuesTotal;
      if (!Number.isInteger(count) || count < 1 || !Number.isFinite(sum) || sum < count || sum > count * 5) return null;
      return {count: count.toLocaleString('en-US'), average: (sum / count).toFixed(1)};
    }).catch(() => null);
  }
  const update = () => window[key].then(result => {
    if (!result) return;
    document.querySelectorAll('[data-oc-review-count]').forEach(el => { el.textContent = `${result.count} Customer Reviews`; });
    document.querySelectorAll('[data-oc-review-rating]').forEach(el => { el.textContent = `${result.average} average rating`; });
  });
  update();
  if (!window.__ocCollectionReviewListener) {
    window.__ocCollectionReviewListener = true;
    document.addEventListener('shopify:section:load', update);
  }
})();
